module.exports = __webpack_public_path__ + "img/android_doctor.723d22dd.png";